import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import moment from "moment";
import pickUpInformationFieldProps from "../../services/models/formModels/pickUpInformationFieldsProps.model";

function PickupInformationFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  getFieldMeta,
  setFieldValue,
  availableTimeOptions,
}: pickUpInformationFieldProps): JSX.Element {
  const closeTimeSuggestions = dataConstants.TimeData.filter((time) => {
    let currentTime = moment().get("hours");
    let timeHour = time.value.split(":")[0];

    if (Number(timeHour) - currentTime <= 0) {
      return false;
    }

    return true;
  }).map((time) => ({ label: time.label, value: time.label }))
  return (
    <FieldRenderer
      fields={dataConstants.pickupInformationFields.map((field, index) => ({
        key: `${index}${field.id}`,
        ...field,
        getFieldMeta,
        setFieldValue,
        values,
        errors: errors,
        touched: touched,
        onChange: handleChange,
        value: values?.[!!field?.name ? field.name : ""],
        onBlur: handleBlur,
        name: field.name,
        roundedInput: true,
        disabled:
          field.name === "readyDateTimestamp" && availableTimeOptions.length === 0,
        suggestions:
          field.name === "closeTime"
            ? closeTimeSuggestions
            : field.name === "readyDateTimestamp"
            ? availableTimeOptions
            : undefined,
        parentContainerClass:
          ["pickupDate", "closeTime"].includes?.(
            field?.name ? field.name : ""
          ) && `${field.parentContainerClass}`,
      }))}
    />
  );
}

export default PickupInformationFields;
